// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  // PASTE_YOUR_CONFIG_HERE
  apiKey: "AIzaSyCjIlobtj0wuRcKCYLXTQtNeCW6Jy133SU",
  authDomain: "trend-genie-11dac.firebaseapp.com",
  projectId: "trend-genie-11dac",
  storageBucket: "trend-genie-11dac.firebasestorage.app",
  messagingSenderId: "150282620199",
  appId: "1:150282620199:web:5d8a249a5b6356ec9f6d02",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "europe-west2");

export { app, auth, db, functions };
